module.exports = __webpack_public_path__ + "img/basquecountry.6a3df1aa.svg";